import { ref, type Ref } from "vue"
import { defineStore } from "pinia"
import type { WorkPeriodTemplate } from "@/models/work-period-template.model.ts"

export const useWorkPeriodTemplateStore = defineStore("workPeriodTemplateStore", () => {
  // Standard work period templates ("standaard werkdagen") of the app user.
  const workPeriodTemplates: Ref<WorkPeriodTemplate[]> = ref([])
  const workPeriodTemplatesFetched = ref(false)

  function clearWorkPeriodTemplates() {
    workPeriodTemplates.value = []
    workPeriodTemplatesFetched.value = false
  }

  return {
    workPeriodTemplates,
    workPeriodTemplatesFetched,
    clearWorkPeriodTemplates
  }
})
